import { gql } from '@apollo/client';

export const fetchMachineList = gql`
  query machines($pagingOptions: PagingOptionsInput!) {
    machines(pagingOptions: $pagingOptions) {
      data {
        id
        alias
        materialNumber
        serialNumber
        lastConnectedAt
        health
        location {
          name
        }
        facility
        object
      }
      metadata {
        totalCount
      }
    }
  }
`;
